<template>
  <div id="app" :style="`background-color: ${store.theme.viewMode.backgroundColor[store.theme.viewMode.active]}`">
    <transition name="fade">
      <main-nav-bar v-if="store.render.MainNavBar"></main-nav-bar>
    </transition>
    
    <div style="min-height: 90vh; height: 100%">
      <router-view></router-view>
    </div>
    
    <el-dialog :show-close="false" class="home-modal" :visible.sync="store.modal.visible" top="3vh">
      <el-row class="home-modal" slot="title" align="center">
        <el-col :span="23" style="text-align: center">
          <span style="color: #eeeeee; margin-left: 15px; font-size: 1.2em;">
            {{ store.modal.title[store.modal.component] }} </span>
        </el-col>
        <el-col :span="1" align="right">
          <i class="fas icon-fa-times-circle" style="color: white; cursor: pointer; font-size: 1.2em;"
            @click="store.modal.visible = false"></i>
        </el-col>
      </el-row>
      <component :is="store.modal.component" :key="store.events.trigger"></component>
    </el-dialog>

    <main-footer :lastUpdated="store.constants.lastUpdated"></main-footer>
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'
import MainNavBar from '@/components/MainNavBar.vue'
import MainFooter from '@/components/MainFooter.vue'


export default {
  name: 'app',
  components: {
    MainNavBar, 
    MainFooter,
    SettingsPanel: () => import('@/components/SettingsPanel.vue'), 
    MetadataTable: () => import('@/components/MetadataTable.vue'), 
  },
  data() {
    return { store }
  },
  mounted() {
    setTimeout(store.render.methods.loadMainNavBar(), 500)
  },
  created() {
    this.loadGlobalDatasets()
    this.loadAcknowledgements()
    this.loadGenomeData()
    this.loadMapData()
    // this.loadReinfectionData()
  },
  methods: {
    loadAcknowledgements(){
      store.methods.loadAcknowledgements('Called loadAcknowledgements from App.vue')
    },
    loadGenomeData() {
      store.methods.loadGenomeData('Called loadGenomeData from App.vue')
    },
    loadReinfectionData() {
      store.methods.loadReinfectionData('Called loadReinfectionData from App.vue')
    },
    loadMapData() {
      store.methods.loadStateMapData('Called loadStateMapData from App.vue')
      store.methods.loadDistrictMapData('Called loadDistrictMapData from App.vue')
    },
    loadGlobalDatasets() {
      store.methods.loadGlobalDatasets()
    }
  }
}
</script>

<style>
#app {
  font-family: 'Manrope', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.home-modal .el-dialog {
  max-width: 1000px;
}

.home-modal div .el-dialog__header {
  font-weight: bold;
  background-color:  #4e4e4e;
  color: #eeeeee;
  font-size: 1.2em;
  padding: 15px !important;
  padding-left: 30px !important;
}
</style>

<style lang="scss">
$fa-css-prefix: 'icon-fa';
$fa-font-path: '~@fortawesome/fontawesome-free/webfonts';

@import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
@import '~@fortawesome/fontawesome-free/scss/solid.scss';
@import '~@fortawesome/fontawesome-free/scss/brands.scss';

// Override Element UI's icon font
.fas {
  font-family: 'Font Awesome 5 Free' !important;
}

.fab {
  font-family: 'Font Awesome 5 Brands' !important;
}

html,body {
  height:100%;
}

.el-tooltip__popper {
  font-family: 'Manrope', Helvetica, Arial, sans-serif;
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-input__inner {
  font-family: 'Manrope', Helvetica, Arial, sans-serif;
}

.el-select-dropdown__list {
  font-family: 'Manrope', Helvetica, Arial, sans-serif;
}

.histogram-card .el-card__header {
  font-weight: bold;
  background: linear-gradient(90deg, #5254a0, #7b7fc4);
  color: #eeeeee;
}

.state-pie-card .el-card__header {
  font-weight: bold;
  background: linear-gradient(90deg, #0062ca, #009fd9);
  color: #eeeeee;
}

.fade-enter-active {
  transition: opacity 1s;
}

.fade-leave-active {
  transition: opacity 0.5;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>